



































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ProfessionalSummaryDetailsModel,
  ProfessionalSummaryOrganizationAndPatient,
} from "@/types/aznconnect_api";
import InformationCard from "@/components/InformationCard.vue";

@Component({
  components: {
    "information-card": InformationCard,
  },
})
export default class MetaDataView extends Vue {
  @Prop({ default: null })
  psModel!: ProfessionalSummaryDetailsModel;

  @Prop()
  advancedMode!: boolean;

  @Prop()
  referral!: any;

  referralModel!: any;

  patientEqualToPSPatient(
    model: ProfessionalSummaryOrganizationAndPatient,
  ): boolean {
    const referral = this.referral;

    var patientModel = model.PatientModel;

    if (
      referral.PatientBSN != (patientModel == null ? null : patientModel.Bsn) ||
      referral.PatientName !=
        (patientModel == null ? null : patientModel.GivenName) +
          " " +
          (patientModel == null ? null : patientModel.FamilyName) ||
      referral.Gender != (patientModel == null ? null : patientModel.Gender) ||
      referral.PatientBirthDate !=
        (patientModel == null ? null : patientModel.BirthDate) ||
      referral.PatientAddressLine1 !=
        (patientModel == null ? null : patientModel.Street) +
          " " +
          (patientModel == null ? null : patientModel.HouseNumber) ||
      referral.PatientAddressLine2 !=
        (patientModel == null ? null : patientModel.PostalCode) +
          " " +
          (patientModel == null ? null : patientModel.City) ||
      referral.PatientAddressLine3 !=
        (patientModel == null ? null : patientModel.Country)
    ) {
      return false;
    } else {
      return true;
    }
  }
}
